import { SkeletonTableBody } from './SkeletonTableBody';

export default SkeletonTableBody;
